export default "__VITE_ASSET__BbOsrqvE__"